import {inject, Injectable} from '@angular/core';
import {BreakpointObserver} from '@angular/cdk/layout';
import {toSignal} from '@angular/core/rxjs-interop';
import {map} from 'rxjs/operators';
import {carouselBreakpoints} from '../configs/carousel-config';

@Injectable({
  providedIn: 'root'
})
export class CarouselBreakpointService {
  private breakpointObserver = inject(BreakpointObserver);

  private breakpointQueries = [
    carouselBreakpoints.mobile.query,
    carouselBreakpoints.tablet.query
  ];

  private breakpointState$ = this.breakpointObserver.observe(this.breakpointQueries).pipe(
    map(state => {
      const breakpoints = state.breakpoints;

      return breakpoints[carouselBreakpoints.mobile.query]
        ? carouselBreakpoints.mobile.visibleItems
        : breakpoints[carouselBreakpoints.tablet.query]
        ? carouselBreakpoints.tablet.visibleItems
        : null;
    })
  );

  public breakpointVisibleItems = toSignal(this.breakpointState$, { initialValue: null });
}

